import useDefinedContext from "hooks/useDefinedContext";
import { createContext } from "react";
import type { Status } from "types/Status";

const ChartSetSelectStatusContext = createContext<Status | undefined>(undefined);
ChartSetSelectStatusContext.displayName = "ChartSetSelectStatusContext";

export function useChartSetSelectStatusContext() {
  return useDefinedContext(ChartSetSelectStatusContext);
}

export default ChartSetSelectStatusContext;
